import * as React from 'react';
import {
  CircleWavyCheckIcon,
  FactoryIcon,
  CoinsIcon,
  ThumbsUpIcon,
  ShieldCheckIcon,
} from '@fronton/icons-react';

export type ConstructionHousesBenefitsStructure = {
  icon: React.ReactNode;
  text: string;
};

export const CONSTRUCTION_HOUSES_BENEFITS_DATA: ConstructionHousesBenefitsStructure[] = [
  {
    icon: <CircleWavyCheckIcon strokeWidth={0.85} type="outline" size="48px" color="text-primary" />,
    text: 'Оригинальные товары',
  },
  {
    icon: <FactoryIcon strokeWidth={0.85} type="outline" size="48px" color="text-primary" />,
    text: 'Прямые контракты с\u00A0производителями',
  },
  {
    icon: <CoinsIcon strokeWidth={0.85} type="outline" size="48px" color="text-primary" />,
    text: 'Низкие цены каждый день',
  },
  {
    icon: <ThumbsUpIcon strokeWidth={0.85} type="outline" size="48px" color="text-primary" />,
    text: 'Выгодные акции и\u00A0предложения',
  },
  {
    icon: <ShieldCheckIcon strokeWidth={0.85} type="outline" size="48px" color="text-primary" />,
    text: 'Проверенные специалисты',
  },
];
